import { Link } from "react-router-dom";
import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";
import { TexteFooter, MiniTexte } from "../../utils/style/elements.tsx";
import Youtube from "../../assets/images/icons/w-ytb.svg";
import Github from "../../assets/images/icons/w-gh.svg";
import Linkedin from "../../assets/images/icons/w-lkd.svg";
import Itch from "../../assets/images/icons/w-itch.svg";



const FooterWrapper = styled.footer`    
    width: 100%;
`


const FooterContainer = styled.div`
    background-color: ${colors.black};
    color: ${colors.white} !important;
    display: flex;
    justify-content: space-between;
    height: 80px;
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: row;

    @media (max-width: 768px) {
        flex-direction: column;
        height: 100px;
        padding: 2%;
        width: 96%;
    }
`;

const FooterTitleWrapper = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    width: 100%;
`;

const FooterIconsWrapper = styled.div`
    display: flex;
    gap: 60px;
    justify-content: center;
    width: 100%;

    @media (max-width: 900px) {
        gap: 45px;
    }
    
    @media (max-width: 768px) {
        gap: 30px;
        margin-bottom: 17px;
    }
`;

const StyledLink = styled(Link)`
    color: ${colors.white};
    text-decoration: none;
    display: flex;
`;

const IconLink = styled.img`
    width: 48px;
    height: 48px;

    @media (max-width: 768px) {
        width: 25px;
        height: 25px;
    }
`



const BottomTextContainer = styled.div`
    background-color: ${colors.white};
    color: ${colors.gray} !important;

`;

const StyledLinkBottom = styled(Link)`
    color: ${colors.gray};
    text-decoration: none;

    &:hover{
        border-bottom: solid 1px ${colors.gray};
    }
`;

const StyledMiniTexte = styled(MiniTexte)`
    font-size: 13px;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 11px;
    }
`


function Footer() {
    return (
        <FooterWrapper>
            <FooterContainer>
                    <FooterTitleWrapper>
                        <TexteFooter>
                            Alexandre Kotowicz - Portfolio
                        </TexteFooter>
                    </FooterTitleWrapper>
                    <FooterIconsWrapper>
                        <StyledLink to="https://www.youtube.com/channel/UCf_GOXuzxP3zWIn8xGXD2NQ" target="_blank">
                            <IconLink src={Youtube} />
                        </StyledLink>

                        <StyledLink to="https://github.com/AlexandreKcz" target="_blank">
                            <IconLink src={Github} />
                        </StyledLink>

                        <StyledLink to="https://www.linkedin.com/in/alexandre-kotowicz-785739214/?originalSubdomain=fr" target="_blank">
                            <IconLink src={Linkedin} />
                        </StyledLink>

                        <StyledLink to="https://alexandre-kotowicz.itch.io/" target="_blank">
                            <IconLink src={Itch} />
                        </StyledLink>
                    </FooterIconsWrapper>
            </FooterContainer>
            <BottomTextContainer>
                <StyledMiniTexte>
                    © Alexandre Kotowicz. 2025. 
                    <StyledLinkBottom to="https://clip-web.fr" target="_blank"> Clip Web. </StyledLinkBottom>
                    All rights reserved.
                </StyledMiniTexte>
            </BottomTextContainer>
        </FooterWrapper>
    );
}

export default Footer;
